import { Modal } from '~/components';
import { IoMdCloseCircleOutline } from 'react-icons/io';

import { formatDecimal } from '~/utils';
import { Content, TitleModal, Line, Container, Title } from './styles';

interface IProps {
  list: any;
  onClick: () => void;
}

const ModalDetails: React.FC<IProps> = ({ onClick, list }: IProps) => {
  return (
    <Modal>
      <Container>
        <TitleModal>
          <button type="button" onClick={onClick}>
            <IoMdCloseCircleOutline />
          </button>
        </TitleModal>
        <Content>
          <Title>Detalhes</Title>
          <Line>
            <b>Dirigente</b>
            <p>
              {list.pastor}({list.pastor_present ? 'Presente' : 'Ausente'})
            </p>
          </Line>
          <Line>
            <b>Oferta</b>
            <p>
              {'R$ '}
              {formatDecimal(list?.offers)}
            </p>
          </Line>
          <Line>
            <b>Dízimo</b>
            <p>
              {'R$ '}
              {formatDecimal(list?.tithes)}
            </p>
          </Line>
          {list.frequencyClasse.map((element: any) => {
            return (
              <>
                <Line>
                  <b>{element.classe.name}</b>{' '}
                  <p>{element.attendance} alunos</p>
                </Line>
                {element.justification && (
                  <Line>
                    <b>Justificativa</b> <p>{element.justification}</p>
                  </Line>
                )}
              </>
            );
          })}
          <Line>
            <b>Observação</b>
            <p>{list.comments}</p>
          </Line>
          {list.out_of_date_justification && (
            <>
              <Line>
                <b>Justificativa da Data: </b>
              </Line>
              <Line>
                <p>{list.out_of_date_justification}</p>
              </Line>
            </>
          )}
        </Content>
      </Container>
    </Modal>
  );
};

export default ModalDetails;
